import React, { useState, useEffect } from "react";
import {
    Alert,
    Avatar,
    Box,
    Button,
    Card,
    CardActionArea,
    CardContent,
    CardMedia,
    Chip,
    Container,
    Dialog,
    DialogContent,
    Grid,
    IconButton,
    Skeleton,
    Snackbar,
    Stack,
    Typography,
    Breadcrumbs,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ShareIcon from "@mui/icons-material/Share";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FetchSinglebizurl } from "../Utils/urls";
import { isDesktop } from "react-device-detect";
import Universalheader from "../Headers/universalheader";
import SignIn from "../Common/login";
import Sharepopup from "../Components/sharepopup";
import { primarycolor } from "../Utils/colors";
import MapComponent from "../Hostels/mapcomponent";
import { getsessionuser, setsessionhouse } from "../Utils/sessions";
import Shuffle from "../Utils/shuffle";
import { admindetails } from "../Utils/defaults";
import fallbackImage from "./../../assets/common/image2.png";

const Viewsinglebusiness = ({ onrefresh }) => {
    const user = getsessionuser();
    const location = useLocation();
    const navigate = useNavigate();
    const email = location.pathname.split("/")[3];

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [showLoginPopup2, setShowLoginPopup2] = useState(false);
    const [sharePopupOpen, setSharePopupOpen] = useState(false);
    const [showImage, setShowImage] = useState(false);

    const [defaultUrl, setDefaultUrl] = useState("");

    const [business, setBusiness] = useState({});
    const [catalogue, setCatalogue] = useState([]);

    useEffect(() => {
        fetchBusiness();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchBusiness = () => {
        setLoading(true);
        axios
            .post(FetchSinglebizurl, { email })
            .then((response) => {
                setLoading(false);
                if (!response.data.message) {
                    setBusiness(response.data);
                    setCatalogue(response.data.catalogue || []);
                } else {
                    setError(response.data.message);
                }
            })
            .catch(() => {
                setLoading(false);
                setError("Sorry there was an error, try again later");
            });
    };

    const shareUrl = `https://eazistey.co.ke/nav/viewsinglebusiness/${email}`;

    const startChat = () => {
        setsessionhouse(business.status !== "paid" ? admindetails : business);
        user
            ? navigate("/nav/chats", { state: { message: "startchart" } })
            : setShowLoginPopup(true);
    };

    const onSuccessLogin = () => {
        setsessionhouse(business.status !== "paid" ? admindetails : business);
        navigate("/nav/chats", { state: { message: "startchart" } });
    };

    const onSuccessLogin2 = () => {
        onrefresh();
        navigate("/nav/mybusinesses", { state: { message: "addbiz" } });
    };

    const gotoMyBusinesses = () => {
        user
            ? navigate("/nav/mybusinesses", { state: { message: "addbiz" } })
            : setShowLoginPopup2(true);
    };

    const openService = (val) => {
        navigate("/nav/viewsingleservice", { state: { item: val } });
    };

    return (
        <Box sx={{ bgcolor: "grey.50", minHeight: "100vh" }}>
            <Snackbar
                open={Boolean(error)}
                autoHideDuration={3000}
                onClose={() => setError("")}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert severity="error" onClose={() => setError("")}>
                    {error}
                </Alert>
            </Snackbar>

            {/* Login modal - start chat */}
            <Dialog open={showLoginPopup} onClose={() => setShowLoginPopup(false)} maxWidth="xs" fullWidth>
                <SignIn onsuccesslogin={onSuccessLogin} />
            </Dialog>

            {/* Login modal - list a business */}
            <Dialog open={showLoginPopup2} onClose={() => setShowLoginPopup2(false)} maxWidth="xs" fullWidth>
                <SignIn onsuccesslogin={onSuccessLogin2} />
            </Dialog>

            {/* Share modal */}
            <Dialog open={sharePopupOpen} onClose={() => setSharePopupOpen(false)} maxWidth="xs" fullWidth>
                <Sharepopup name="Share Business link through" link={shareUrl} />
            </Dialog>

            {/* Full image preview */}
            <Dialog open={showImage} onClose={() => setShowImage(false)} maxWidth="md" fullWidth>
                <IconButton
                    onClick={() => setShowImage(false)}
                    sx={{ position: "absolute", top: 8, right: 8, bgcolor: "background.paper" }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent sx={{ p: 0 }}>
                    <Box component="img" src={defaultUrl} sx={{ width: "100%", display: "block" }} />
                </DialogContent>
            </Dialog>

            <Universalheader />

            <Box sx={{ py: 3, width: '90%', margin: "auto" }}>
                {/* Advertise strip */}
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    justifyContent="flex-end"
                    sx={{ mb: 2, cursor: "pointer" }}
                    onClick={gotoMyBusinesses}
                >
                    <AutoAwesomeIcon sx={{ color: primarycolor }} fontSize="small" />
                    <Typography variant="body2" sx={{ color: primarycolor, fontWeight: 600 }}>
                        List on Eazistey
                    </Typography>
                </Stack>

                {/* Title + share */}
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                    <Typography variant="h4" fontWeight={700} sx={{ textTransform: "uppercase" }}>
                        {loading ? <Skeleton width={240} /> : business.bname}
                    </Typography>
                    <Button
                        startIcon={<ShareIcon />}
                        onClick={() => setSharePopupOpen(true)}
                        size="small"
                        color="inherit"
                    >
                        Share
                    </Button>
                </Stack>

                {/* Breadcrumbs */}
                <Breadcrumbs sx={{ mb: 3 }}>
                    <Link to="/nav" style={{ textDecoration: "none", color: "inherit" }}>
                        Home
                    </Link>
                    <Typography
                        component="span"
                        onClick={() => navigate(-1)}
                        sx={{ cursor: "pointer" }}
                        color="text.secondary"
                    >
                        Services
                    </Typography>
                    <Typography color="text.primary">{business.bname}</Typography>
                </Breadcrumbs>

                <Grid container spacing={4}>
                    {/* Left: business details */}
                    <Grid item xs={12} md={5}>
                        <Card variant="outlined">
                            {loading ? (
                                <Skeleton variant="rectangular" height={260} />
                            ) : (
                                <CardMedia
                                    component="img"
                                    image={business.url}
                                    alt={business.bname}
                                    onClick={() => {
                                        setShowImage(true);
                                        setDefaultUrl(business.url);
                                    }}
                                    sx={{ height: 260, objectFit: "cover", cursor: "pointer" }}
                                />
                            )}
                            <CardContent>
                                {loading ? (
                                    <>
                                        <Skeleton />
                                        <Skeleton width="60%" />
                                    </>
                                ) : (
                                    <>
                                        <Typography variant="body1" sx={{ mb: 1 }}>
                                            {business.description}
                                        </Typography>
                                        {business.service && (
                                            <Chip label={business.service} size="small" sx={{ fontWeight: 600 }} />
                                        )}
                                    </>
                                )}

                                <Typography variant="subtitle2" sx={{ mt: 3, mb: 1.5, fontWeight: 700 }}>
                                    Contact Details
                                </Typography>

                                <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} sx={{ mb: 2 }}>
                                    <Button
                                        variant="contained"
                                        href={`tel:${business.phone}`}
                                        startIcon={<PhoneIcon />}
                                        sx={{ bgcolor: primarycolor, "&:hover": { bgcolor: primarycolor } }}
                                        fullWidth
                                    >
                                        Call the Owner
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={startChat}
                                        startIcon={<ChatBubbleOutlineIcon />}
                                        fullWidth
                                    >
                                        Chat
                                    </Button>
                                </Stack>

                                <Stack direction="row" spacing={1.5} alignItems="center">
                                    <Avatar src={business.url} alt={business.username} />
                                    <Box>
                                        <Typography variant="body2" fontWeight={700}>
                                            {business.username}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            Contact person
                                        </Typography>
                                    </Box>
                                </Stack>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Right: catalogue */}
                    <Grid item xs={12} md={7}>
                        <Typography variant="h6" fontWeight={700} sx={{ mb: 2 }}>
                            Catalogue
                        </Typography>
                        <Grid container spacing={2}>
                            {loading
                                ? Array.from({ length: 4 }).map((_, i) => (
                                    <Grid item xs={6} sm={4} key={i}>
                                        <Skeleton variant="rectangular" height={140} sx={{ borderRadius: 1 }} />
                                    </Grid>
                                ))
                                : Shuffle(catalogue)?.map((val, key) => (
                                    <Grid item xs={6} sm={4} key={key}>
                                        <Card variant="outlined" sx={{ height: "100%" }}>
                                            <CardActionArea onClick={() => openService(val)} sx={{ height: "100%" }}>
                                                <CardMedia
                                                    component="img"
                                                    height="110"
                                                    image={val?.url || fallbackImage}
                                                    alt={val?.name}
                                                    sx={{ objectFit: "cover" }}
                                                />
                                                <CardContent sx={{ p: 1.5 }}>
                                                    <Typography variant="body2" fontWeight={700} noWrap>
                                                        {val?.name}
                                                    </Typography>
                                                    <Typography
                                                        variant="caption"
                                                        color="text.secondary"
                                                        sx={{
                                                            display: "-webkit-box",
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: "vertical",
                                                            overflow: "hidden",
                                                        }}
                                                    >
                                                        {val?.description?.substring(0, 40)}
                                                    </Typography>
                                                    <Typography variant="body2" fontWeight={700} sx={{ mt: 0.5 }}>
                                                        {val?.price} Ksh
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                ))}
                        </Grid>
                    </Grid>
                </Grid>

                {/* Map (desktop, non-remote businesses only) */}
                {isDesktop && business.type !== "remote" && catalogue[0]?.longitude && (
                    <Box sx={{ mt: 5 }}>
                        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
                            <Typography variant="h6" fontWeight={700}>
                                Visit shop
                            </Typography>
                            <Button
                                size="small"
                                href={`https://maps.eazistey.co.ke/?longitude=${catalogue[0]?.longitude}&latitude=${catalogue[0]?.latitude}`}
                            >
                                View directions
                            </Button>
                        </Stack>
                        <MapComponent
                            longitude={catalogue[0]?.longitude}
                            latitude={catalogue[0]?.latitude}
                        />
                        <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 1.5 }}>
                            {catalogue[0]?.location}, Chuka, Kenya
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default Viewsinglebusiness;